var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "md:ml-8 flex-1" }, [
    _c(
      "div",
      { staticClass: "p-2 sm:p-6 bg-white rounded-lg" },
      [
        _c("SectionHeader", {
          attrs: { title: "Interventions", currentUser: _vm.currentUser },
          on: {
            edit: function ($event) {
              return _vm.$emit("edit")
            },
          },
        }),
        _c("hr", { staticClass: "border-t border-gray-100 mb-4" }),
        _c(
          "InfoSection",
          [
            _c("InfoField", { attrs: { label: "Dietary / Nutrition" } }, [
              _c("p", { staticClass: "text-gray-600" }, [
                _vm._v(
                  " Frequency: " +
                    _vm._s(_vm.data.dietary_goals_frequency || "N/A")
                ),
                _c("br"),
                _vm._v(
                  " Special Requirements: " +
                    _vm._s(
                      _vm.data.dietary_goals_special_requirement || "N/A"
                    ) +
                    " "
                ),
              ]),
            ]),
            _c("InfoField", { attrs: { label: "Light Housekeeping" } }, [
              _c("p", { staticClass: "text-gray-600" }, [
                _vm._v(
                  " Daily Tasks: " +
                    _vm._s(_vm.data.housekeeping_daily_task || "N/A")
                ),
                _c("br"),
                _vm._v(
                  " Assistance Level: " +
                    _vm._s(_vm.data.housekeeping_assistance_level || "N/A") +
                    " "
                ),
              ]),
            ]),
            _c("InfoField", { attrs: { label: "Ambulation Assistance" } }, [
              _c("p", { staticClass: "text-gray-600" }, [
                _vm._v(
                  " Support Type: " +
                    _vm._s(_vm.data.ambulance_support_type || "N/A")
                ),
                _c("br"),
                _vm._v(
                  " Pain Monitoring: " +
                    _vm._s(_vm.data.ambulance_pain_monitoring || "N/A") +
                    " "
                ),
              ]),
            ]),
            _c("InfoField", { attrs: { label: "Bathing" } }, [
              _c("p", { staticClass: "text-gray-600" }, [
                _vm._v(
                  " Frequency: " + _vm._s(_vm.data.bathing_frequency || "N/A")
                ),
                _c("br"),
                _vm._v(
                  " Supervision Level: " +
                    _vm._s(_vm.data.bathing_supervision_level || "N/A") +
                    " "
                ),
              ]),
            ]),
            _c("InfoField", { attrs: { label: "Toileting" } }, [
              _c("p", { staticClass: "text-gray-600" }, [
                _vm._v(
                  " Frequency: " + _vm._s(_vm.data.toileting_frequency || "N/A")
                ),
                _c("br"),
                _vm._v(
                  " Hygiene: " + _vm._s(_vm.data.toileting_hygiene || "N/A")
                ),
                _c("br"),
                _vm._v(
                  " General Notes: " +
                    _vm._s(_vm.data.toileting_notes || "N/A") +
                    " "
                ),
              ]),
            ]),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }